import * as React from "react";

import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FormContainer from "~/containers/TrackTrace/FormContainer";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";

interface IProps {
  orderNumber: string;
  postalCode: string;
}

class NotFound extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, orderNumber, postalCode } = this.props;

    return (
      <>
        <Callout
          intent="danger"
          title={t("errors.notFound.title")}
          icon="error"
        >
          <div>
            <Trans i18nKey="trackTrace:errors.notFound.description">
              We konden geen bestelling vinden met ordernummer '
              {{ orderNumber }}' en/of postcode '{{ postalCode }}
              '. ijk goed of het ordernummer goed is overgenomen en/of je
              postcode klopt. Het zou ook kunnen dat je bestelling niet is
              betaald. Bekijk{" "}
              <Link to="/faq/payments/no-payment-confirmation">hier</Link> hoe
              je de betaalstatus kunt inzien. Lukt het nog niet?{" "}
            </Trans>
          </div>
        </Callout>

        <FormContainer />
      </>
    );
  }
}

export default withTranslation("trackTrace")(NotFound);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/NotFound.tsx